var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6H3.75C2.505 6 1.5 7.005 1.5 8.25V11.25C1.5 12.075 2.175 12.75 3 12.75H4.5V14.25C4.5 15.075 5.175 15.75 6 15.75H12C12.825 15.75 13.5 15.075 13.5 14.25V12.75H15C15.825 12.75 16.5 12.075 16.5 11.25V8.25C16.5 7.005 15.495 6 14.25 6ZM11.25 14.25H6.75C6.3375 14.25 6 13.9125 6 13.5V10.5H12V13.5C12 13.9125 11.6625 14.25 11.25 14.25ZM14.25 9C13.8375 9 13.5 8.6625 13.5 8.25C13.5 7.8375 13.8375 7.5 14.25 7.5C14.6625 7.5 15 7.8375 15 8.25C15 8.6625 14.6625 9 14.25 9ZM12.75 2.25H5.25C4.8375 2.25 4.5 2.5875 4.5 3V4.5C4.5 4.9125 4.8375 5.25 5.25 5.25H12.75C13.1625 5.25 13.5 4.9125 13.5 4.5V3C13.5 2.5875 13.1625 2.25 12.75 2.25Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.1a29de90633669761ac18bfde6df7070.svg";
export { ForwardRef as ReactComponent };